import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { fetchItems } from "../../actions/expertActions";
import {
  makeExpertPreviewsSelector,
  makeExpertPreviewsFetchStatusSelector,
} from "../../selectors/expertPreviews";
import { EXPERT_SHAPE } from "../../constants/expertConstants";
import { COLLECTION_FETCH_STATUS_SHAPE } from "../../selectors/collections";
import LoadableCollection from "../../components/ui/loadable/collection";


export function withExperts(WrappedComponent) {

  const WithExperts = class extends Component {

    componentDidMount() {
      this.fetchExperts();
    }

    shouldComponentUpdate(prevProps) {
      if (prevProps.fetchStatus && prevProps.fetchStatus.isFetching) {
        return false
      } else {
        return true
      }
    }

    fetchExperts = () => {
      const { fetchItems, fetchStatus } = this.props;

      if (!fetchStatus.isFetching) {
        fetchItems();
      }
    };

    render() {
      const { experts, fetchStatus, children, ...restProps } = this.props;

      return (
        <LoadableCollection fetchStatus={fetchStatus}>
          {
            () => <WrappedComponent
                    {...restProps}
                    experts={experts}
                    fetchExperts={this.fetchExperts}
                  />
          }
        </LoadableCollection>
      )
    }
  };

  WithExperts.propTypes = {
    experts: PropTypes.arrayOf(PropTypes.shape(EXPERT_SHAPE)),
    fetchStatus: PropTypes.shape(COLLECTION_FETCH_STATUS_SHAPE).isRequired,
  };

  const expertsSelector = makeExpertPreviewsSelector();
  const expertsFetchStatusSelector = makeExpertPreviewsFetchStatusSelector();

  function mapStateToProps(state) {
    return {
      experts: expertsSelector(state),
      fetchStatus: expertsFetchStatusSelector(state),
    }
  }

  function mapDispatchToProps(dispatch) {
    return bindActionCreators({
      fetchItems,
    }, dispatch)
  }

  return connect(mapStateToProps, mapDispatchToProps)(WithExperts);
}